import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import getFormatedFloat from "../../../../Utils/getFormatedFloat";
import { PAYMENT_RECEIVER_TYPE } from "../../data";

export const CommodityColumn = ({ payment }) => {
  const [produces, setProduces] = useState([]);

  const getProduces = useCallback(() => {
    const uniqueProduces = [];

    const local = payment.produceDetails.filter(
      (item) => item.weightCollected > 0,
    );

    local.forEach((item) => {
      if (!uniqueProduces.find((p) => p.produceId === item.produceId)) {
        uniqueProduces.push({
          produceId: item.produceId,
          produceName: item.produceName,
        });
      }
    });

    setProduces(uniqueProduces);
  }, [payment]);

  useEffect(() => {
    getProduces();
  }, [getProduces]);

  return (
    <div>
      {produces.map((item, index) => (
        <p
          key={item.produceId}
          className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize"
          style={{
            marginTop: index !== 0 && "8px",
            textTransform: "capitalize",
          }}
        >
          {item?.produceName}
        </p>
      ))}
    </div>
  );
};

export const WeightCollectedColumn = ({ payment }) => {
  const [produces, setProduces] = useState([]);

  const getProduces = useCallback(() => {
    const local = payment?.produceDetails?.filter(
      (item) => item.weightCollected > 0,
    );

    const unique = local.reduce((acc, current) => {
      const found = acc.find((item) => item.produceId === current.produceId);

      if (found) {
        found.weightCollected += current.weightCollected;
      } else {
        acc.push({
          produceId: current?.produceId,
          produceName: current?.produceName,
          weightCollected: parseFloat(current.weightCollected),
          unit: current?.unit?.slice(4),
        });
      }

      return acc;
    }, []);

    setProduces(unique);
  }, [payment]);

  const getWeight = (item) => {
    // return item?.weightCollected
    // ? `${parseFloat(item.weightCollected).toFixed(2)} ${item.unit}`
    //   : 0;
    return item?.weightCollected
      ? `${getFormatedFloat(item.weightCollected)} ${item.unit}`
      : 0;
  };

  useEffect(() => {
    getProduces();
  }, [getProduces]);

  return (
    <div>
      {produces.map((item, index) => (
        <p
          key={item.produceId}
          className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize"
          style={{
            marginTop: index !== 0 && "8px",
            textTransform: "capitalize",
          }}
        >
          {/* {item?.weightCollected} {item?.unit} */}
          {getWeight(item)}
        </p>
      ))}
    </div>
  );
};

export const RateColumn = ({ payment }) => {
  const { selectedPayment } = useSelector((state) => state.revenue);

  const [rates, setRates] = useState([]);

  const getRates = useCallback(() => {
    const uniqueRates = [];

    const local = payment.produceDetails.filter(
      (item) => item.weightCollected > 0,
    );

    local.forEach((item) => {
      if (!uniqueRates.find((p) => p.produceId === item.produceId)) {
        uniqueRates.push({
          produceId: item.produceId,
          produceName: item.produceName,
          unit: item.unit,
          rate:
            +selectedPayment.entityType === PAYMENT_RECEIVER_TYPE.DRIVER
              ? item?.commissionRate
              : item?.paymentRate,
        });
      }
    });

    setRates(uniqueRates);
  }, [payment, selectedPayment]);

  useEffect(() => {
    getRates();
  }, [getRates]);

  return (
    <div>
      {rates.map((item, index) => (
        <p
          key={item.produceId}
          className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize"
          style={{
            marginTop: index !== 0 && "8px",
            textTransform: "capitalize",
          }}
        >
          {item?.rate} KSH/{item?.unit}
        </p>
      ))}
    </div>
  );
};

export const AmountCommodityColumn = ({ payment }) => {
  const [produces, setProduces] = useState([]);

  const getProduces = useCallback(() => {
    const local = payment?.produceDetails?.filter(
      (item) => item.weightCollected > 0,
    );

    const unique = local.reduce((acc, current) => {
      const found = acc.find((item) => item.produceId === current.produceId);

      if (found) {
        found.amount += current.amount;
      } else {
        acc.push({
          produceId: current.produceId,
          produceName: current.produceName,
          amount: parseFloat(current.amount),
          unit: current?.unit?.slice(4),
        });
      }

      return acc;
    }, []);

    setProduces(unique);
  }, [payment]);

  const getAmount = (item) => {
    // return item?.amount ? `${parseFloat(item?.amount).toFixed(2)} KSH` : 0;
    return item?.amount ? `${getFormatedFloat(item?.amount)} KSH` : 0;
  };

  useEffect(() => {
    getProduces();
  }, [getProduces]);

  return (
    <div>
      {produces.map((item, index) => (
        <p
          key={item.produceId}
          className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize"
          style={{ marginTop: index !== 0 && "8px" }}
        >
          {/* {item?.amount} KSH */}
          {getAmount(item)} - {item.produceName}
        </p>
      ))}
    </div>
  );
};

export const TotalCommodityAmountColumn = ({ record }) => {
  const totalAmount = () => {
    const total = record?.produceDetails?.reduce((acc, current) => {
      acc += parseFloat(current.amount);
      return acc;
    }, 0);

    return total > 0 ? `${parseFloat(total).toFixed(0)} KSH` : "--";
  };

  const isEdited = record?.produceDetails?.some((item) => +item.isEdited === 1);

  return (
    <div className="text-xs font-medium font-poppins leading-4.5">
      {totalAmount()}

      {isEdited && <p className="text-yellow-dark">Edited</p>}
    </div>
  );
};

export const TotalAmountColumn = ({ record }) => {
  const totalAmount = () => {
    const activity = record?.produceDetails?.reduce((acc, current) => {
      acc += parseFloat(current.amount);
      return acc;
    }, 0);

    const battery = record?.batteryRevenue?.reduce((acc, current) => {
      acc += parseFloat(current?.cost || 0);
      return acc;
    }, 0);

    const total = parseFloat(activity) - parseFloat(battery);

    return total > 0 ? `${parseFloat(total).toFixed(0)} KSH` : "--";
  };

  const isEdited = record?.produceDetails?.some((item) => +item.isEdited === 1);

  return (
    <div className="text-xs font-medium font-poppins leading-4.5">
      {totalAmount()}

      {isEdited && <p className="text-yellow-dark">Edited</p>}
    </div>
  );
};

export const sortByTotalAmount = (a, b) => {
  const totalAmount = (record) => {
    const activity = record?.produceDetails?.reduce((acc, current) => {
      acc += parseFloat(current.amount);
      return acc;
    }, 0);

    const battery = record?.batteryRevenue?.reduce((acc, current) => {
      acc += parseFloat(current?.cost || 0);
      return acc;
    }, 0);

    const total = parseFloat(activity) - parseFloat(battery);

    return total > 0 ? total : 0;
  };

  const first = totalAmount(a);
  const second = totalAmount(b);

  return second - first;
};

export const EnergyConsumedColumn = ({ record }) => {
  const getUsage = () => {
    if (!record?.batteryRevenue?.length) return "--";

    const total = record?.batteryRevenue?.reduce((acc, current) => {
      acc += parseFloat(current?.usage || 0);
      return acc;
    }, 0);

    if (Number.isNaN(total)) return "--";
    return `${getFormatedFloat(total)} kWh`;
  };

  return (
    <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
      {getUsage()}
    </div>
  );
};

export const AmountPerEnergyConsumedColumn = ({ record }) => {
  const getAmount = () => {
    if (!record?.batteryRevenue?.length) return "--";

    const total = record?.batteryRevenue?.reduce((acc, current) => {
      acc += parseFloat(current?.cost || 0);
      return acc;
    }, 0);

    if (Number.isNaN(total)) return "--";
    return `${getFormatedFloat(total)} KSH`;
  };

  return (
    <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
      {getAmount()}
    </div>
  );
};

// sessions
export const SessionTotalAmountColumn = ({ record }) => {
  const getUsage = () => {
    if (!record?.batteryRevenue?.length) return "--";

    const commission = parseFloat(record?.commissionAmount || 0);

    if (commission === 0) return "--";

    const battery = record?.batteryRevenue?.reduce((acc, current) => {
      acc += parseFloat(current?.cost || 0);
      return acc;
    }, 0);

    const total = parseFloat(commission) - parseFloat(battery);

    if (Number.isNaN(total)) return "--";
    return `${getFormatedFloat(total)} KSH`;
  };

  return (
    <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
      {getUsage()}
    </div>
  );
};
